export default __webpack_public_path__ + "static/media/building2.9cbe56dc.webp";